<ng-container *ngIf="message" >
  <!-- Toolbar + patient bar are sticky together so it's always visible which
       patient this message is about, even scrolled deep into a long
       thread/attachment list. -->
  <div class="updox-detail-sticky-header">
    <!-- Toolbar -->
    <div class="updox-detail-toolbar">
      <h4 class="updox-detail-subject m0" title="{{ message.display_subject }}">
        {{ message.display_subject }}
      </h4>
      <div class="updox-detail-actions">

        <!-- Draft actions -->
        <ng-container *ngIf="isDraft">
          <button type="button" class="btn btn-primary mr-sm" (click)="editDraft.emit(message)">
            <i class="fa fa-pencil mr-sm"></i>Edit &amp; Send
          </button>
        </ng-container>

        <!-- Inbox / Sent actions -->
        <ng-container *ngIf="!isDraft">
          <button tooltip="Reply" type="button" class="btn btn-secondary btn-outline btn-sm mr" (click)="replyToMessage()">
            <i class="fa fa-reply"></i>
          </button>
          <button tooltip="Mark as unread" type="button" class="btn btn-tertiary btn-outline btn-sm mr"
                  *ngIf="message.folder === 'inbox' && message.read"
                  [disabled]="isMarkingUnread"
                  (click)="markUnread()">
            <i class="fa fa-envelope-open" *ngIf="isMarkingUnread"></i>
            <i class="fa fa-envelope" *ngIf="!isMarkingUnread"></i>
          </button>
        </ng-container>

        <!-- Attachments toggle — only shown when the message actually has attachments -->
        <!--      <button tooltip="View attachments" type="button" class="btn btn-default btn-outline btn-sm mr"-->
        <!--              *ngIf="isInbound && message.has_attachments"-->
        <!--              (click)="showAttachments = !showAttachments"-->
        <!--              [class.active]="showAttachments">-->
        <!--        <i class="fa fa-paperclip"></i>-->
        <!--      </button>-->
        <button tooltip="Delete" type="button" class="btn btn-danger btn-outline btn-sm"
                (click)="confirmDelete()" [disabled]="isDeleting">
          <i class="fa fa-trash" *ngIf="!isDeleting"></i>
          <i class="fa fa-spinner fa-spin mr-sm" *ngIf="isDeleting"></i>

        </button>
      </div>
    </div>

    <!-- Patient link bar (inbox/sent — drafts manage their patient in compose).
         Single place in the whole message view where the patient is searched,
         matched, added, or changed — attachment rows and the Clinical Summary
         panel below only ever read message.patient_id, never re-offer this. -->
    <div class="updox-detail-patient-bar" *ngIf="!isDraft"
         [class.updox-detail-patient-bar-linked]="message.patient_id">

      <!-- Linked -->
      <div class="updox-detail-patient-linked" *ngIf="message.patient_id">
        <span class="updox-avatar updox-avatar-xs">{{ patientDisplayName.charAt(0).toUpperCase() }}</span>
        <div class="updox-detail-patient-info">
          <span class="fw-500 fs13">{{ patientDisplayName }}</span>
          <span class="text-muted fs12 ml-sm" *ngIf="patientDemographics(linkedPatientDetail) as demo">· {{ demo }}</span>
          <span class="text-secondary fw-500 fs11 ml-sm">— linked patient</span>
        </div>
        <a class="btn btn-sm btn-primary btn-outline" (click)="unlinkPatient()"
           [class.disabled]="isLinking || hasChartedAttachments"
           [title]="hasChartedAttachments ? 'Cannot change patient — an attachment from this message has been added to their chart' : 'Change patient'">
          <i class="fa fa-spinner fa-spin" *ngIf="isLinking"></i>
          <i class="fa fa-pencil" *ngIf="!isLinking"></i>
        </a>
      </div>

      <!-- Not linked: status line (checking / auto-detected candidate / nothing
           found) stacked above an always-visible search box — no extra click
           to reveal it, and the box itself offers "Add New Patient" when a
           search comes up empty. -->
      <div class="updox-detail-patient-unlinked" *ngIf="!message.patient_id">

        <!-- Checking — shown for the entire time we don't yet know the final
             state (verifying an already-linked patient, or running the C-CDA
             auto-detect check), instead of committing to "No patient linked" and
             having that silently flip to something else once the body and
             attachments already look "done loading" and the user has moved on. -->
        <div class="updox-detail-patient-status" *ngIf="isCheckingPatient">
          <i class="fa fa-spinner fa-spin text-muted fs13"></i>
          <span class="text-muted fs12">Checking for a linked patient…</span>
        </div>

        <!-- Auto-detected from a C-CDA attachment — one-click confirm instead of
             making the user open Clinical Summary to discover who it's about.
             Still goes through full SMS/KBA authorization on Confirm; only the
             *detection* is automatic, never the authorization. -->
        <div class="updox-detail-patient-status updox-fade-in" *ngIf="!isCheckingPatient && ccdaCandidate">
          <i class="fa fa-file-text-o text-info fs13"></i>
          <span class="fs12">This message's clinical document appears to be for</span>
          <span class="fw-500 fs13 ml-sm">{{ ccdaCandidate.name }}</span>
          <span class="text-muted fs12 ml-sm" *ngIf="patientDemographics(ccdaCandidate) as demo">· {{ demo }}</span>
          <a class="btn btn-xs btn-success ml-sm" (click)="confirmCcdaCandidate()" [class.disabled]="isConfirmingCcdaCandidate">
            <i class="fa fa-spinner fa-spin mr-sm" *ngIf="isConfirmingCcdaCandidate"></i>
            <i class="fa fa-check mr-sm" *ngIf="!isConfirmingCcdaCandidate"></i>Confirm
          </a>
          <a class="btn btn-xs btn-default btn-outline ml-sm" (click)="dismissCcdaCandidate()">Not this patient</a>
        </div>

        <!-- Nothing detected — plain "not linked" status; the search box below
             is always there regardless, this is just the label above it. -->
        <div class="updox-detail-patient-status" *ngIf="!isCheckingPatient && !ccdaCandidate">

          <div class="media">
            <div class="media-left">
               <i class="fa fa-user-o updox-avatar updox-avatar-md text-danger fs16" style="background-color: #fbebeb;">! </i></div>
            <div class="media-body">
              <div class="fw-500">
              <span class="text-danger" >No patient linked</span></div>
<!--            <div ><p class="updox-detail-patient-hint" *ngIf="ccdaNoMatchHint">-->
              <div ><p class="updox-detail-patient-hint">
              No automatic match found in the clinical document — search or add the patient below.
            </p>
            </div>
            </div>
          </div>
        </div>

        <!-- C-CDA was parsed but nothing in the chart matched it — point staff
             at the search/add box below instead of leaving them to guess why
             there's no auto-detected candidate. -->
      </div>

      <!-- Search — searches all of Wellwink and gates unauthorized patients
           behind SMS/KBA; also offers "Add New Patient" (prefilled from the
           C-CDA document's demographics when there's one to read) right in
           the dropdown when no search result is the right one. The component
           itself is always mounted (never *ngIf on it, unlike the blocks
           above) so verifyLinkedPatient()'s on-load check has a stable
           @ViewChild and its modal stays free to show even while the Linked
           chip is what's actually visible; [hidden] on this wrapping div is
           what actually hides the box in that case. -->
      <div class="updox-detail-patient-search" [hidden]="!!message.patient_id">
        <div class="updox-patient-search-wrap">
          <app-patient-authorize-search #linkPatientSearch
                                        [addPatientPrefill]="docPatientPrefill"
                                        placeholder="Search patient by name, phone or email…"
                                        inputClass="form-control input-sm updox-patient-search-input"
                                        name="messageDetailLinkPatientSearch"
                                        (patientSelected)="selectLinkPatient($event)">
          </app-patient-authorize-search>
        </div>
        <!--      <i class="fa fa-spinner fa-spin updox-patient-search-spinner text-muted" *ngIf="isLinking"></i>-->
      </div>
    </div>
  </div>

  <!-- Reply chain banner — outbound reply we sent -->
  <div class="updox-reply-banner updox-reply-banner-sent" *ngIf="message.reply_to_message_id && !isInbound">
    <i class="fa fa-reply mr-xs"></i>
    This is a reply you sent to an earlier message.
  </div>

  <!-- Reply chain banner — inbound reply received from the other party -->
  <div class="updox-reply-banner updox-reply-banner-received" *ngIf="isInbound && message.subject?.startsWith('Re:')">
    <i class="fa fa-reply mr-xs"></i>
    This is a reply from <strong>{{ message.from_address }}</strong> to one of your messages.
  </div>

  <!-- Added-to-chart badge -->
  <div class="updox-chart-badge-bar" *ngIf="message.added_to_medical_chart">
    <span class="updox-chart-badge">
      <i class="fa fa-check-circle mr-xs"></i>Added to Medical Chart
    </span>
  </div>

  <!-- Inline delete confirm -->
  <div class="alert alert-danger p-sm m-sm" *ngIf="showDeleteConfirm">
    {{ deleteConfirmText }}
    <div class="pull-right">
      <a class="btn btn-xs btn-danger mr-sm" (click)="deleteMessage()">Yes, Delete</a>
      <a class="btn btn-xs btn-default" (click)="cancelDelete()">Cancel</a>
    </div>
  </div>

  <!-- Meta -->
  <div class="updox-detail-meta">
    <div class="media">
      <div class="media-left">
        <span class="updox-avatar updox-avatar-lg bg-secondary">
          {{ isDraft ? (message.to_address?.charAt(0)?.toUpperCase() || '?') : message.sender_initial }}
        </span>
      </div>
      <div class="media-body">
        <ng-container *ngIf="isDraft">
          <div class="fw-500">{{ message.to_address }}</div>
          <div class="text-muted fs13">To: {{ message.to_address }}</div>
          <div class="text-muted fs13">{{ message.updated_at | date:'MMM d, y · HH:mm' }}</div>
        </ng-container>
        <ng-container *ngIf="!isDraft">
          <div class="fw-500">{{ message.display_sender }}</div>
          <div class="text-muted fs13">To: {{ message.to_address }}</div>
          <div class="text-muted fs13">{{ message.created_at | date:'MMM d, y · HH:mm' }}</div>
        </ng-container>
      </div>
    </div>
  </div>

  <hr class="m0">


  <!-- Attachment panel -->
  <div class="updox-attachments-section-header fw-500" *ngIf="message.has_attachments" >
    <i class="fa fa-paperclip mr-sm "> </i>Attachments (2)
  </div>
  <div class="updox-attachments-section" >
    <app-updox-attachments [message]="message" [readOnly]="!isInbound"
                           (ccdaPatientDetected)="onCcdaPatientDetected($event)"></app-updox-attachments>
  </div>

  <hr class="m0">
  <!-- Message body — loaded on demand via get :direct_message to keep the list payload light -->
  <div class="updox-detail-body">
    <div *ngIf="isLoadingBody" class="text-center p-md text-muted">
      <i class="fa fa-spinner fa-spin mr-sm"></i>Loading...
    </div>
    <ng-container *ngIf="!isLoadingBody">
      <div *ngIf="fullMessage?.body_html" [innerHTML]="fullMessage.body_html | safeHtml"></div>
      <pre *ngIf="!fullMessage?.body_html && fullMessage?.body_text" class="updox-body-text">{{ fullMessage.body_text }}</pre>
      <p *ngIf="!fullMessage?.body_html && !fullMessage?.body_text" class="text-muted">(No content)</p>
    </ng-container>
  </div>


</ng-container>

<!--&lt;!&ndash; Empty state &ndash;&gt;-->
<!--<div *ngIf="!message" class="updox-detail-empty">-->
<!--  <i class="fa fa-envelope-o fs40 d-block mb"></i>-->
<!--  <p class="m0">Select a message to read</p>-->
<!--</div>-->
